<script>
import { h, resolveComponent } from 'vue';

export default {
  name: 'c-breadcrumb-item',
  props: {
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: null
    },
    current: {
      type: Boolean,
      default: false
    }
  },
  emits: ['itemClick'],
  computed: {},
  methods: {
    onClick() {
      if (!this.current) {
        this.$emit('itemClick');
      }
    }
  },
  render() {
    const { label, color, $theme, current } = this;
    const cLabel = resolveComponent('c-label');
    return h(
      cLabel,
      {
        style: [
          {
            cursor: current ? 'default' : label === 'Home' || label === '홈' ? 'pointer' : 'default'
          }
        ],
        size: 12,
        color: color ? $theme.COLOR.UI.UI01 : $theme.COLOR.UI.UI05,
        onClick: this.onClick
      },
      () => [label]
    );
  }
};
</script>
<style lang="scss" scoped></style>
